export function renderDateField({
	inputId,
	label,
	labelPlacement = 'inside',
	inputClass = '',
	inputAttrs,
}: {
	inputId: string
	label: string
	labelPlacement?: 'inside' | 'outside'
	inputClass?: string
	inputAttrs?: {
		name?: string
		max?: string
		required?: boolean
		value?: string
	}
}): string {
	const labelPlacementClass =
		labelPlacement === 'outside' ? 'label-outside' : ''
	const labelMarkup = `<label for="${inputId}" class="f secondary">${label}:</label>`
	const nameAttr = inputAttrs?.name ?? inputId
	const maxAttr = inputAttrs?.max ? ` max="${inputAttrs.max}"` : ''
	const valueAttr = inputAttrs?.value ? ` value="${inputAttrs.value}"` : ''
	const requiredAttr = inputAttrs?.required ? ' required' : ''

	return `
        <div class="tt-select tt-date-field ${labelPlacementClass}">
            ${labelPlacement === 'outside' ? labelMarkup : ''}
            <input type="date" id="${inputId}" name="${nameAttr}" class="select-auto-width ${inputClass}"${valueAttr}${maxAttr}${requiredAttr} />
            ${labelPlacement === 'inside' ? labelMarkup : ''}
        </div>
    `
}
